<template v-if="fundingData">
  <div>
    <dx-data-grid
      v-if="fundingData"
      :data-source="fundingData.profiles[0].cRMFundingProfileV2s"
      :show-borders="true"
      :column-auto-width="true"
      :word-wrap-enabled="true"
      :ref="dataGridDetail"
      :no-data-text="$t('general.noEntries')"
    >
      <dx-paging :page-size="5"/>

      <dx-column
        data-field="field_001"
        :caption="$t('fundings.list.id')"
      />
      <dx-column
        data-field="datum"
        data-type="date"
        format="dd.MM.yyyy"
        :caption="$t('fundings.list.date')"
        alignment="right"
      />
      <dx-column
        data-field="closingdate"
        data-type="date"
        format="dd.MM.yyyy"
        :caption="$t('fundings.list.closingDate')"
        alignment="right"
      />
      <dx-column
        data-field="cRMFundingJOINProfilProfileV2s"
        cell-template="investors-template"
        :caption="$t('fundings.list.investor')"
      />
      <dx-column
        data-field="comment"
        :caption="$t('fundings.list.comment')"
        :width="300"
      />
      <dx-column
        data-field="moneyinCHF"
        :caption="$t('fundings.list.money')"
        :format="totalFormat"
      />
      <template #investors-template="{ data }">
        <div v-if="data.data.cRMFundingJOINProfilProfileV2s">
          <span
            v-for="investor in data.data.cRMFundingJOINProfilProfileV2s"
            :key="investor.field_001"
          >
            <span v-if="investor.profil_idId">{{investor.profile.cRMAddress.company}}<br></span>
          </span>
        </div>
      </template>
      <dx-summary>
        <dx-total-item
          column="moneyinCHF"
          summary-type="sum"
        >
          <dx-value-format
            :precision="2"
            format="currency"
          />
        </dx-total-item>
      </dx-summary>
    </dx-data-grid>
  </div>
</template>

<script>
  import {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSummary,
    DxTotalItem,
    DxValueFormat
  } from 'devextreme-vue/data-grid'

  const dataGridDetail = 'dataGrid'

  export default {
    props: {
      fundingData: {
        type: Object,
        default: () => (undefined)
      }
    },
    data: () => ({
      dataGridDetail,
      totalFormat: { style: 'currency', currency: 'CHF', useGrouping: true, minimumSignificantDigits: 3 }
    }),
    methods: {
      async onUpdateRow (rowData) {
        const { data } = rowData

        try {
          await this.$store.dispatch('event/UPDATE_FUNDING', {
            formData: data,
            id: data.id
          })
        } catch (err) {
          console.error(err)
        }
      }
    },
    computed: {
      dataGrid: function () {
        return this.$refs[dataGridDetail].instance
      }
    },
    components: {
      DxDataGrid,
      DxColumn,
      DxPaging,
      DxSummary,
      DxTotalItem,
      DxValueFormat
    }
  }
</script>
